import React from "react";
import PropTypes from "prop-types";
import AboutToCallYou from "./AboutToCallYou";
import CallInProgress from "./CallInProgress";
import CallError from "./CallError";
import CallDone from "./CallDone";
import CallPopupWrapper from "./CallPopupWrapper";
import { updateNumber } from "../../../services/callService";

const initialState = {
  updatedNumber: null,
  saveNumber: true,
  status: "",
  inProgress: false,
  finalStatus: "",
  finished: false,
};

class PreCallPopup extends React.Component {
  static propTypes = {
    calleeName: PropTypes.string.isRequired,
    myNumber: PropTypes.string.isRequired,
    onUpdateNumber: PropTypes.func,
    requestCall: PropTypes.func.isRequired,
    dismiss: PropTypes.func.isRequired,
  };

  state = initialState;

  reset() {
    this.setState(initialState);
  }

  async requestCall() {
    await this.setState({
      inProgress: true,
      status: "",
      finalStatus: "",
      finished: false,
    });

    return this.props.requestCall((callData) => {
      if (typeof callData === "string") {
        this.setState({ status: callData, finalStatus: "", finished: true });
      } else if (callData.error) {
        this.setState({
          inProgress: false,
          status: callData.error,
          finalStatus: "failed",
          finished: true,
        });
      } else {
        this.setState({
          inProgress: !callData.callFinished,
          status: callData.callMsgStat,
          finalStatus: callData.finalStatus,
          finished: callData.callFinished,
        });
      }
    }, this.state.updatedNumber);
  }

  onChangeNumber = (updatedNumber) => this.setState({ updatedNumber });
  onChangeSaveNumber = (saveNumber) => this.setState({ saveNumber });

  getRenderDetails() {
    const { inProgress, finished, finalStatus } = this.state;
    const isFailed = finalStatus === "failed";
    // connect/pending/no response/failed/finished
    if (inProgress) {
      return this.getCallInProgressRenderDetails();
    }
    if (finished) {
      if (isFailed) {
        return this.getCallFailedRenderDetails();
      }
      return this.getCallCompletedRenderDetails();
    }
    return this.getStartCallRenderDetails();
  }

  get number() {
    const { myNumber } = this.props;
    const { updatedNumber } = this.state;
    return updatedNumber || myNumber;
  }

  getCallInProgressRenderDetails() {
    return {
      button: {
        text: "Calling",
        extraClass: "button__calling",
        disabled: true,
      },
      component: <CallInProgress />,
      title: "Connecting...",
    };
  }

  getCallFailedRenderDetails() {
    const { status } = this.state;
    return {
      button: {
        text: "Try Again",
        handleClick: async () => this.handleClickForEditablePhoneNumber(),
      },
      component: (
        <CallError
          callStatus={status}
          number={this.number}
          onChangeNumber={this.onChangeNumber}
          onChangeSaveNumber={this.onChangeSaveNumber}
        />
      ),
      title: "Call Failed",
    };
  }

  getCallCompletedRenderDetails() {
    const { dismiss, calleeName } = this.props;
    const { status } = this.state;
    return {
      button: {
        text: "Close",
        handleClick: () => {
          this.reset();
          dismiss();
        },
      },
      component: <CallDone callStatus={status} />,
      title: `Successfully contacted ${calleeName}`,
    };
  }

  getStartCallRenderDetails() {
    return {
      button: {
        text: "Start Call",
        handleClick: async () => this.handleClickForEditablePhoneNumber(),
      },
      component: (
        <AboutToCallYou
          number={this.number}
          onChangeNumber={this.onChangeNumber}
          onChangeSaveNumber={this.onChangeSaveNumber}
        />
      ),
      title: "Start the call",
    };
  }

  async handleClickForEditablePhoneNumber() {
    const { onUpdateNumber, myNumber } = this.props;
    const { updatedNumber, saveNumber } = this.state;
    if (saveNumber && updatedNumber && updatedNumber !== myNumber) {
      await updateNumber(updatedNumber);
      if (typeof onUpdateNumber === "function") {
        onUpdateNumber(updatedNumber);
      }
    }
    return this.requestCall();
  }

  render() {
    const { title, button, component } = this.getRenderDetails();

    return (
      <CallPopupWrapper
        title={title}
        footer={
          <button
            type="submit"
            className={`button button--dark ${button.extraClass || ""}`.trim()}
            onClick={button.handleClick}
            disabled={button.disabled}
          >
            {button.text}
          </button>
        }
      >
        {component}
      </CallPopupWrapper>
    );
  }
}

export default PreCallPopup;
